/* ═══════════════════════════════════════════════════════════════════
   Full Color patch handoff (from the Embroidery 2.0 builder).
   Loaded only on the sublimated-patches PDP. When the URL carries
   np_proof=<approved AI render> (+ file=<artwork> for the legacy flow),
   this displays the approved proof on the page and attaches it to the
   line item — the customer just picks size/qty and checks out. No
   proofing happens again on this page.
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var params = new URLSearchParams(window.location.search);
  var proof = params.get('np_proof');
  if (!proof || proof.indexOf('http') !== 0) return;
  /* C506 (PATCH-2122494): a My Proofs re-order (np_reorder) is np-emb2's own arrival lane — this legacy stamp overwrote its
     'Reordered from My Proofs' status with 'Approved in Embroidered builder - Full Color recommendation' */
  if (params.get('np_reorder')) return;
  /* C567 (Justin 2026-11-04, PATCH-2126864): on a 2-0 page the builder runs this hand-off itself (np-emb2 handleProofHandoff
     marks the proof approved and writes the real status, "Approved in Embroidered builder - converted to FULL COLOR …").
     This legacy stamp overwrote that status with "Full Color recommendation" and re-wrote _AI Proof / _cartImg /
     _Original Image for 15 s over the builder's own values. It stays for the legacy (non-2-0) page only. */
  if (document.getElementById('np-e2')) return;
  var w = params.get('np_w'), h = params.get('np_h'), qty = params.get('np_qty'), notes = params.get('np_notes');
  var originalArt = params.get('np_art'); /* the customer's true source upload */
  /* lineage guard: the proof name embeds the original upload's suffix —
     an np_art that doesn't share it is not this customer's artwork */
  (function () {
    var m = /____((?:image|img)?_?\d{9,}_\d+)/.exec(String(proof || ''));
    if (m && originalArt && String(originalArt).indexOf(m[1]) === -1) originalArt = '';
  })();

  function setProp(name, value) {
    var form = document.querySelector('product-form.product-form form');
    if (!form) return;
    var el = form.querySelector('[name="properties[' + name + ']"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + name + ']';
      form.appendChild(el);
    }
    el.value = value == null ? '' : value;
    el.disabled = false;
  }

  function attach() {
    /* line-item contract: the approved proof is the cart thumbnail and
       travels with the order */
    setProp('_AI Proof', proof);
    setProp('_cartImg', proof);
    setProp('_AI Proof Status', 'Approved in Embroidered builder - Full Color recommendation');
    if (notes) setProp('_AI Proof Notes', notes);
    /* the proof arrived as the working file (file=), so the legacy flow
       writes it into _Original Image too — restore the TRUE source upload
       there, and keep re-asserting while the legacy timers rewrite props */
    if (originalArt && originalArt.indexOf('http') === 0) setProp('_Original Image', originalArt);
    var n = 0;
    var iv = setInterval(function () {
      setProp('_AI Proof', proof);
      setProp('_cartImg', proof);
      if (originalArt && originalArt.indexOf('http') === 0) setProp('_Original Image', originalArt);
      if (++n > 10) clearInterval(iv);
    }, 1500);
  }

  function panel() {
    if (document.getElementById('np-fc-panel')) return;
    var anchor = document.querySelector('.disabled-cta.second-upload-cta') ||
                 document.querySelector('product-form.product-form') ||
                 document.getElementById('uploadArea');
    if (!anchor || !anchor.parentElement) return;
    var el = document.createElement('div');
    el.id = 'np-fc-panel';
    el.innerHTML =
      '<style>' +
      '#np-fc-panel{border:1.5px solid #1AA86C;background:#f4fff9;border-radius:12px;padding:16px;margin:16px 0;display:flex;align-items:center;gap:16px;font-family:inherit}' +
      '#np-fc-panel img{width:96px;height:96px;object-fit:contain;border-radius:8px;background:#fff;flex:0 0 auto}' +
      '#np-fc-panel b{display:block;font-size:15px;color:#0f172a;margin-bottom:3px}' +
      '#np-fc-panel span{font-size:13px;color:#16202b;line-height:1.5}' +
      '</style>' +
      '<img src="' + proof.replace(/"/g, '&quot;') + '" alt="Approved AI proof">' +
      '<div><b>Your approved AI proof is attached ✓</b>' +
      '<span>This Full Color proof from the patch builder is saved to your order' +
      (w && h ? ' · designed at ' + w + '" × ' + h + '"' : '') +
      '. Confirm your size and quantity below, then add to cart — no need to proof again.</span></div>';
    anchor.parentElement.insertBefore(el, anchor);
  }

  function boot() {
    attach();
    /* panel appears once the legacy flow has loaded the artwork */
    var tries = 0;
    var iv = setInterval(function () {
      var ua = document.getElementById('uploadArea');
      if ((ua && ua.classList.contains('hidden')) || ++tries > 40) {
        clearInterval(iv);
        panel();
      }
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
